import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: 'login_layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['login_layout.component.css']
})
export class LoginLayoutComponent {
}
